// Copyright (c) 2016 Deere & Company

import DbsAutoSubmit, {getDefaultState as getDbsAutoSubmitDefaultState} from './dbs-autosubmit';
import DbsClaimTypes, {getDefaultState as getDbsClaimTypesDefaultState} from './dbs-claim-types';
import t from 'tcomb';

const DbsSettings = t.struct({
    autoSubmit: DbsAutoSubmit,
    claimTypes: DbsClaimTypes
}, {
    name: 'DbsSettings',
    strict: true
});

export const getDefaultState = () => new DbsSettings({
    autoSubmit: getDbsAutoSubmitDefaultState(),
    claimTypes: getDbsClaimTypesDefaultState()
});

export default DbsSettings;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/dbs-settings.js